import React from 'react';
import { MailOutline, PhoneInTalkOutlined, Place } from '@mui/icons-material';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { PhysicianSupervisee } from '@uplift/api';
import { useL10n } from '@uplift/hooks';
import { useStatesQuery } from '@uplift/queries';
import { getPrescriberLabel } from '@uplift/utils';


export type SuperviseeProviderProfileGeneralInfoProps = {
  supervisee: PhysicianSupervisee;
};


export const SuperviseeProviderProfileGeneralInfo: React.VFC<SuperviseeProviderProfileGeneralInfoProps> = ({ supervisee }) => {
  const l10n = useL10n();
  const { data: states = [] } = useStatesQuery();
  const prescriberLabel = getPrescriberLabel(supervisee.prescriberType, l10n.resources.provider.prescriberTypes);
  const licensedLabel = states
    .filter(state => supervisee.licenseStateIds.includes(state.id))
    .map(state => state.shortName)
    .join(', ');

  return (
    <Box>
      <Box sx={{ p: 2 }}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {supervisee.user.firstName} {supervisee.user.lastName}
        </Typography>
        {prescriberLabel && (
          <Typography color="text.secondary">{prescriberLabel}</Typography>
        )}
      </Box>
      <Divider />
      <Stack spacing={2} sx={{ p: 4 }}>
        {supervisee.user.email && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <MailOutline fontSize="small" color="action" />
            <Typography>{supervisee.user.email}</Typography>
          </Box>
        )}
        {supervisee.user.phones.length > 0 ? (
          supervisee.user.phones.map(phone => (
            <Box key={phone.name} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <PhoneInTalkOutlined fontSize="small" color="action" />
              <Typography>{phone.value} {l10n.resources.contacts.labelByName[phone.name] ?? phone.name}</Typography>
            </Box>
          ))
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <PhoneInTalkOutlined fontSize="small" color="action" />
            <Typography>No phone number</Typography>
          </Box>
        )}
        {licensedLabel && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Place fontSize="small" color="action" />
            <Typography>Licensed: {licensedLabel}</Typography>
          </Box>
        )}
      </Stack>
    </Box>
  );
};
